<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            <h3>Formulário de Cadastro de Contrato de Link</h3>
                            <i @click="$emit('close')" class="fas fa-times-circle"></i>
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            <form id="register-contract" method="post" >
                                <div class="form-group">
                                    <div class="form-field">
                                        <label>Código do Contrato:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Código do contrato" v-model="contractCode" required>
                                            <i class="fas fa-fingerprint" />
                                        </div>
                                        <span class="form-error" v-if="validateContractCode">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-field">
                                        <label>Nome do Cliente:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Nome completo do cliente" v-model="clientName" required>
                                            <i class="fas fa-user" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateClientName">Este campo é obrigatório</span>
                                    </div>
                                    <div class="form-field">
                                        <label>Unidade do Cliente:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Nome da unidade do cliente" v-model="clientUnit">
                                            <i class="fas fa-globe-americas" style="padding: 10px"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-for="(contact, index) in clientContactsName" :key="'client-' + index">
                                    <div class="form-field" >
                                        <label>Nome do Contato no Cliente {{!index ? '' : `(${index + 1})`}}:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Nome do contato" v-model="clientContactsName[index]" required>
                                            <i class="fas fa-user-friends" />
                                        </div>
                                        <span class="form-error" v-if="validateClientContactsName">Este campo é obrigatório</span>
                                    </div>
                                    <div class="form-field">
                                        <label>Telefone do Contato no Cliente {{!index ? '' : `(${index + 1})`}}:</label>
                                        <div class="input-icon" >
                                            <input type="tel" v-model="clientContactsPhone[index]" placeholder="(00)00000-0000" required>
                                            <i class="fas fa-phone" style="padding: 10px"/>
                                            <i v-if="!index" class="fas fa-plus-circle add-more" title="Adicionar mais um contato" @click="addContact('client')" />
                                            <i v-else class="fas fa-minus-circle add-more" title="Remover este contato" @click="removeContact('client', index)" style="color: #e63946"/>
                                        </div>
                                        <span class="form-error" v-if="validateClientContactsPhone">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-field">
                                        <label>Nome do Provedor:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Nome completo do Provedor" v-model="providerName" required>
                                            <i class="fas fa-user" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateProviderName">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group" v-for="(contact, index) in providerContactsName" :key="'provider-' + index">
                                    <div class="form-field">
                                        <label>Nome do Contato no Provedor {{!index ? '' : `(${index + 1})`}}:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Nome do contato" v-model="providerContactsName[index]" required>
                                            <i class="fas fa-user-friends" />
                                        </div>
                                        <span class="form-error" v-if="validateProviderContactsName">Este campo é obrigatório</span>
                                    </div>
                                    <div class="form-field" >
                                        <label>Telefone do Contato no Provedor {{!index ? '' : `(${index + 1})`}}:</label>
                                        <div class="input-icon">
                                            <input type="tel" v-model="providerContactsPhone[index]" placeholder="(00)00000-0000" required>
                                            <i class="fas fa-phone" style="padding: 10px"/>
                                            <i v-if="!index" class="fas fa-plus-circle add-more" title="Adicionar mais um contato" @click="addContact('provider')" />
                                            <i v-else class="fas fa-minus-circle add-more" title="Remover este contato" @click="removeContact('provider', index)" style="color: #e63946"/>
                                        </div>
                                        <span class="form-error" v-if="validateProviderContactsPhone">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-field">
                                        <label>Índice:</label>
                                        <div class="input-icon">
                                            <select name="technology" id="technology" v-model="indice" required>
                                                <option value="" selected disabled>Selecione um tipo</option>
                                                <option value="IPCA">IPCA</option>
                                                <option value="IGPM">IGPM</option>
                                            </select>
                                            <i class="fas fa-bullseye"/>
                                        </div>
                                    </div>

                                    <div class="form-field">
                                        <label style="margin-bottom: 3px;">Renovação Automatica:</label>
                                        <div class="container-switch">
                                            <input v-model="renovation" type="checkbox" class="switch" name="renovation" id="renovation" />
                                            <label for="renovation">Renovar: </label>
                                        </div>
                                    </div>

                                    <!-- <fieldset class="switch-group">
                                        <label>Renovação Automatica</label>
                                        <fieldset class="container-switch">
                                            <input v-model="renovation" type="checkbox" class="switch" name="renovation" id="renovation" />
                                            <label for="renovation">Renovar</label>
                                        </fieldset>
                                    </fieldset> -->
                                </div>

                                <div class="form-group">
                                    <div class="form-field" v-if="permission">
                                        <label>Mensalidade (Reais):</label>
                                        <div class="input-icon">
                                            <input type="text" style="height: 38px;" v-model="monthlyPayment" placeholder="R$ 00,00" required>
                                            <i class="fas fa-dollar-sign" style="padding: 10px 13px"/>
                                        </div>
                                        <span class="form-error" v-if="validateMonthlyPayment">Este campo é obrigatório</span>
                                    </div>

                                    <div class="form-contratc-time" style="width: 49%" v-else>
                                        <label>Fim do Contrato:</label>
                                        <div class="input-icon">
                                            <input type="date" style="height: 38px;" v-model="contractEnd" disabled required>
                                            <i class="fas fa-calendar-times" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateContractEnd">Este campo é obrigatório</span>
                                    </div>

                                    <div class="form-field">
                                        <label>Velocidade Contratada (Megabytes):</label>
                                        <div class="input-icon">
                                            <input type="text" style="height: 38px;" v-model="contractedSpeed" placeholder="Velocidade Contratada em Megabytes" required>
                                            <i class="fas fa-tachometer-alt"/>
                                        </div>
                                        <span class="form-error" v-if="validateContractedSpeed">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group" v-if="permission">
                                    <div class="form-contratc-time">
                                        <label>Inicio do Contrato:</label>
                                        <div class="input-icon">
                                            <input type="date" style="height: 38px;" v-model="contractStart" required>
                                            <i class="fas fa-calendar-check" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateContractStart">Este campo é obrigatório</span>
                                    </div>

                                    <div class="form-contratc-time" style="width: 25%">
                                        <label>Meses de Duração:</label>
                                        <div class="input-icon">
                                            <input type="number" style="height: 38px;" v-model="contractDuration" placeholder="Meses" required>
                                            <i class="fas fa-clock" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateContractDuration">Obrigatório</span>
                                    </div>

                                    <div class="form-contratc-time">
                                        <label>Fim do Contrato:</label>
                                        <div class="input-icon">
                                            <input type="date" style="height: 38px;" v-model="contractEnd" disabled required>
                                            <i class="fas fa-calendar-times" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateContractEnd">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-field">
                                        <label>Endereço de Instalação:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Endereço completo" v-model="address" required>
                                            <i class="fas fa-map-marker-alt" style="padding: 10px"/>
                                        </div>
                                        <span class="form-error" v-if="validateAddress">Este campo é obrigatório</span>
                                    </div>

                                    <div class="form-field">
                                        <label>Serviços:</label>
                                        <div class="input-icon">
                                            <input type="text" style="height: 38px;" v-model="services" placeholder="Serviços prestados para o cliente" required>
                                            <i class="fas fa-wrench"/>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-field">
                                        <label>Config. de IP:</label>
                                        <div class="input-icon">
                                            <input type="text" placeholder="Configuração de IP" v-model="configIP" required>
                                            <i class="fas fa-network-wired"/>
                                        </div>
                                    </div>
                                    <div class="form-field">
                                        <label>Tecnologia Utilizada:</label>
                                        <div class="input-icon">
                                            <select name="technology" id="technology" v-model="technology" required>
                                                <option value="" disabled>Selecione um tipo</option>
                                                <option value="ADSL">ADSL</option>
                                                <option value="Fibra">Fibra</option>
                                                <option value="Metalico">Par Metalico</option>
                                                <option value="Radio">Radio</option>
                                            </select>
                                            <i class="fas fa-project-diagram"/>
                                        </div>
                                        <span class="form-error" v-if="validateTechnology">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="radio-field">
                                        <label>CNPJ da Empresa:</label>
                                        <div class="radio-icon">
                                            <i class="fas fa-city"/>
                                            <div>
                                                <div class="radio-label">
                                                    <input type="radio" name="cnpj" value="13.859.862/001-16" id="cnpj-advance" v-model="cnpjAdvance" required>
                                                    <label for="cnpj-advance">Advance: 13.859.862/001-16</label>
                                                </div>
                                                <div class="radio-label">
                                                    <input type="radio" name="cnpj" value="13.859.914/001-54" id="cnpj-teleadvance" v-model="cnpjAdvance" required>
                                                    <label for="cnpj-teleadvance">TeleAdvance: 13.859.914/001-54</label>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="form-error" v-if="validateCnpjAdvance">Este campo é obrigatório</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="radio-field">
                                        <label>Descrição:</label>
                                        <div class="input-icon">
                                            <textarea v-model="description" placeholder="Adicione uma descrição"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <div class="last-edit" title="Editado por">
                                <i class="fas fa-pencil-alt" v-if="contract"/>
                                <span v-if="contract">{{ contract.updated_by }}</span>
                            </div>

                            <div class="buttons">
                                <button type="submit" class="modal-default-button btn btn-outline-danger" v-if="contract" @click.prevent="handleDelete" form="register-contract">
                                    <i class="fas fa-trash"/>
                                    Excluir
                                </button>
                                <button class="modal-default-button btn btn-outline-danger" v-else @click="$emit('close')">
                                    <i class="fas fa-times-circle"/>
                                    Cancelar
                                </button>
                                <button v-if="!sendData" type="submit" class="modal-default-button btn btn-outline-primary" @click.prevent="handleSubmit" form="register-contract">
                                    <i class="fas fa-save"/>
                                    Salvar
                                </button>
                                <button v-else class="modal-default-button btn btn-primary" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Enviando...
                                </button>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
    props: ['contract', 'permission'],
    data() {
        return {
            id: '',
            contractCode: '',
            clientName: '',
            clientUnit: '',
            clientContactsName: [''],
            clientContactsPhone: [''],
            providerName: '',
            providerContactsName: [''],
            providerContactsPhone: [''],
            monthlyPayment: '',
            address: '',
            contractedSpeed: '',
            contractStart: '',
            contractDuration: '',
            contractEnd: '',
            configIP: '',
            services: '',
            technology: '',
            cnpjAdvance: '',
            description: '',
            indice: '',
            renovation: false,
            validateContractCode: false,
            validateClientName: false,
            validateClientContactsName: false,
            validateClientContactsPhone: false,
            validateProviderName: false,
            validateProviderContactsName: false,
            validateProviderContactsPhone: false,
            validateMonthlyPayment: false,
            validateAddress: false,
            validateContractedSpeed: false,
            validateContractStart: false,
            validateContractDuration: false,
            validateContractEnd: false,
            validateTechnology: false,
            validateCnpjAdvance: false,
            sendData: false,
        }
    },
    computed: {
        maskMoney() {
            return "Xablau"
        },
    },
    methods: {
        create(formData) {
            axios.post(`link_contracts/create`, formData).then(() => {
                this.sendData = false

                Swal.fire({
                    title: 'Contrato salvo 😃',
                    type: 'success',
                    text: `Contrato de Link salvo com sucesso!`
                })

                this.$emit('close')
                this.$emit('updateTable')
            }).catch(error => {
                this.sendData = false

                Swal.fire({
                    title: 'Falha ao salvar 😭',
                    type: 'error',
                    text: `Erro ao salvar o contrato, por favor, tente novamente.`
                })

                console.error(error)
            })
        },
        update(formData) {
            axios.put(`link_contracts/update`, formData).then(() => {
                this.sendData = false

                Swal.fire({
                    title: 'Contrato atualizado 😃',
                    type: 'success',
                    text: `Contrato de Link atualizado com sucesso!`
                })

                this.$emit('close')
                this.$emit('updateTable')
            }).catch(error => {
                this.sendData = false

                Swal.fire({
                    title: 'Falha ao atualizar 😭',
                    type: 'error',
                    text: `Erro ao atualizar o contrato, por favor, tente novamente.`
                })

                console.error(error)
            })
        },
        handleSubmit() {
            this.sendData = true
            if(this.validateForm()) {
                const formData = {
                    id: this.id,
                    contractCode: this.contractCode,
                    clientName: this.clientName,
                    clientUnit: this.clientUnit,
                    clientContacts: this.organizeContacts(this.clientContactsName, this.clientContactsPhone),
                    providerName: this.providerName,
                    renovation: this.renovation,
                    indice: this.indice,
                    providerContacts: this.organizeContacts(this.providerContactsName, this.providerContactsPhone),
                    monthlyPayment: this.monthlyPayment.replace("R$", '').replace(/\s/gm, ''),
                    address: this.address,
                    contractedSpeed: parseInt(this.contractedSpeed),
                    contractStart: this.contractStart,
                    contractDuration: this.contractDuration,
                    contractEnd: this.contractEnd,
                    configIP: this.configIP,
                    services: this.services,
                    technology: this.technology,
                    cnpjAdvance: this.cnpjAdvance,
                    description: this.description,
                }

                this.contract ? this.update(formData) : this.create(formData);
            } else {
                this.sendData = false
            }
        },
        handleDelete() {
            Swal.fire({
                title: 'Deseja realmente excluir esse contrato ? 🙄',
                type: 'question',
                confirmButtonText: "Sim",
                showCancelButton: true,
                cancelButtonText: "Não",
            }).then(result => {
                if(result.value) {
                    this.sendData = true
                    axios.delete(`link_contracts/delete?id=${this.id}`).then(() => {
                        this.sendData = false

                        Swal.fire({
                            title: 'Contrato excluído',
                            type: 'success',
                            text: `Contrato excluido com sucesso 😃`
                        })

                        this.$emit('close')
                        this.$emit('updateTable')
                    }).catch(error => {
                        this.sendData = false

                        Swal.fire({
                            title: 'Falha ao excluir 😭',
                            type: 'error',
                            text: `Erro ao excluir o contrato, por favor, tente novamente.`
                        })

                        console.error(error)
                    })
                }
            });
        },
        validateForm() {
            let errors = 0

            if(!this.contractCode && this.permission) {
                this.validateContractCode = true
                errors++
            } else {
                this.validateContractCode = false
            }

            if(!this.clientName) {
                this.validateClientName = true
                errors++
            } else {
                this.validateClientName = false
            }

            if(!this.clientContactsName[0]) {
                this.validateClientContactsName = true
                errors++
            } else {
                this.validateClientContactsName = false
            }

            if(!this.clientContactsPhone[0]) {
                this.validateClientContactsPhone = true
                errors++
            } else {
                this.validateClientContactsPhone = false
            }

            if(!this.providerName) {
                this.validateProviderName = true
                errors++
            } else {
                this.validateProviderName = false
            }

            if(!this.providerContactsName[0]) {
                this.validateProviderContactsName = true
                errors++
            } else {
                this.validateProviderContactsName = false
            }

            if(!this.providerContactsPhone[0]) {
                this.validateProviderContactsPhone = true
                errors++
            } else {
                this.validateProviderContactsPhone = false
            }

            if(!this.monthlyPayment && this.permission) {
                this.validateMonthlyPayment = true
                errors++
            } else {
                this.validateMonthlyPayment = false
            }

            if(!this.address) {
                this.validateAddress = true
                errors++
            } else {
                this.validateAddress = false
            }

            if(!this.contractedSpeed && this.permission) {
                this.validateContractedSpeed = true
                errors++
            } else {
                this.validateContractedSpeed = false
            }

            if(!this.contractStart && this.permission) {
                this.validateContractStart = true
                errors++
            } else {
                this.validateContractStart = false
            }

            if(!this.contractDuration && this.permission) {
                this.validateContractDuration = true
                errors++
            } else {
                this.validateContractDuration = false
            }

            // if(!this.configIP) {
            //     this.validateConfigIP = true
            //     errors++
            // } else {
            //     this.validateConfigIP = false
            // }

            if(!this.technology) {
                this.validateTechnology = true
                errors++
            } else {
                this.validateTechnology = false
            }

            if(!this.cnpjAdvance && this.permission) {
                this.validateCnpjAdvance = true
                errors++
            } else {
                this.validateCnpjAdvance = false
            }

            return errors > 0 ? false : true
        },
        addContact(target) {
            if(target == 'client') {
                this.clientContactsName.push('');
                this.clientContactsPhone.push('');
            } else {
                this.providerContactsName.push('');
                this.providerContactsPhone.push('');
            }
        },
        removeContact(target, index) {
            if(target == 'client') {
                this.clientContactsName.splice(index, 1)
                this.clientContactsPhone.splice(index, 1)
            } else {
                this.providerContactsName.splice(index, 1)
                this.providerContactsPhone.splice(index, 1)
            }
        },
        organizeContacts(arrayNames, arrayPhones) {
            let contacts = [];
            for (let index = 0; index < arrayNames.length; index++) {
                contacts.push({
                    "name": arrayNames[index],
                    "phone": arrayPhones.map(phone => phone.replace(/\D/gm, ''))[index]
                });
            }

            return contacts;
        }
    },
    watch: {
        contractDuration: function(duration) {
            if(this.contractStart && duration) {
                this.contractEnd = moment(this.contractStart).add(duration, 'months').format("YYYY-MM-DD");
            }
        },
        contractStart: function(start) {
            if(start && this.contractDuration) {
                this.contractEnd = moment(start).add(this.contractDuration, 'months').format("YYYY-MM-DD");
            }
        },
        monthlyPayment: function(value) {
            if(value) {
                // console.log("Antigo", parseFloat(value.replace("R$ ", "")))
                // let novo = parseFloat(value.replace("R$ ", "")).toLocaleString('pt-BR', {
                //     style: 'currency',
                //     currency: 'BRL'
                // });
                // this.monthlyPayment = novo;
                // console.log("Novo", novo)
            }
        }
    },
    mounted() {
        if(this.contract) {
            this.id = this.contract.id;
            this.contractCode = this.contract.contract_code;
            this.clientName = this.contract.client_name;
            this.clientContactsName = [];
            this.clientContactsPhone = [];
            this.clientUnit = this.contract.client_unit;
            this.providerName = this.contract.provider_name;
            this.renovation = this.contract.renovation;
            this.indice = this.contract.indice;
            this.providerContactsName = [];
            this.providerContactsPhone = [];
            this.monthlyPayment = this.contract.monthly_payment.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
            this.address = this.contract.address;
            this.contractedSpeed = this.contract.contracted_speed;
            this.contractStart = this.contract.contract_start;
            this.contractDuration = this.contract.contract_duration;
            this.contractEnd = this.contract.contract_end;
            this.configIP = this.contract.config_ip;
            this.services = this.contract.services;
            this.technology = this.contract.technology;
            this.cnpjAdvance = this.contract.cnpj_advance;
            this.description = this.contract.description;

            this.contract.client_contacts.forEach(contact => {
                this.clientContactsName.push(contact.name);
                this.clientContactsPhone.push(contact.phone);
            });

            this.contract.provider_contacts.forEach(contact => {
                this.providerContactsName.push(contact.name);
                this.providerContactsPhone.push(contact.phone);
            });
        }
    }

}
</script>

<style scoped>
.container-switch {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    width: 170px;
    border-radius: 5px;
    padding: 4px 0px;
    border: 2px solid #aaa;
    background-color: white;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.container-switch label {
    cursor: pointer;
    margin: 0;
}

.container-switch .switch {
    position: relative;
    cursor: pointer;
    appearance: none;
    width: 50px;
    height: 25px;
    border-radius: 20px;
    background-color: #ccc;
    border: 2px solid #ccc;
    outline: none;
    margin-left: 1rem;
    transition: 0.3s;
}

.switch::before {
    content: "";
    position: absolute;
    height: 21px;
    width: 21px;
    border-radius: 50%;
    background: linear-gradient(145deg, #ffffff, #e6e6e6);
    box-shadow:  20px 20px 60px #d9d9d9,
    -20px -20px 60px #ffffff;
    transition: 0.3s ease-in-out;
}

.switch:checked::before {
    transform: translateX(25px);
}

.switch:checked {
    background-color: #3399ff;
    border-color: #3399ff;
}

.switch:checked + label {
    color: #3399ff;
    font-weight: bold;
}

#register-contract {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-error {
    transition: 2s;
    font-size: 0.8em;
    color: white;
    font-weight: 600;
    text-align: center;
    background-color: #e63946;
    margin-top: 1px;
    border-radius: 0 0 10px 10px ;
}

.form-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.form-field {
    display: flex;
    flex-direction: column;
    width: 49%;
    margin-top: 10px;
}

.form-contratc-time {
    display: flex;
    flex-direction: column;
    width: 35%;
    margin-top: 10px;
}

.input-icon, .radio-field {
    position: relative;
    margin-top: -5px;
}

.input-icon input {
    width: 100%;
    border: 2px solid #aaa;
    border-radius: 5px !important;
    outline: none;
    padding: 5px 0px 5px 40px;
    box-sizing: border-box;
    transition: 0.3s;
}

.input-icon select {
    width: 100%;
    border: 2px solid #aaa;
    border-radius: 5px !important;
    outline: none;
    padding: 5px 0px 5px 40px;
    box-sizing: border-box;
    font-size: 1.2em;
    transition: 0.3s;
}

.input-icon textarea {
    width: 100%;
    height: 100px;
    resize: none;
    border: 2px solid #aaa;
    border-radius: 5px !important;
    outline: none;
    padding: 5px;
    color: rgb(31, 31, 31);
    box-sizing: border-box;
    transition: 0.3s;
}

.input-icon i {
    position: absolute;
    left: 2px;
    top: 2px;
    background-color: #aaa;
    color: #fff;
    padding: 10px 8px;
    transition: 0.3s;
}

.input-icon .add-more {
    font-size: 20px;
    position: absolute;
    background-color: transparent;
    left: 90%;
    top: 26%;
    color: #3a86ff;
    padding: 0px;
    cursor: pointer;
}

@media(max-width: 1270px) {
    .input-icon .add-more {
        left: 88%;
    }
}

input:focus, select:focus, textarea:focus {
  border-color: #3a86ff;
  box-shadow: 0 0 8px 0 #3a86ff;
}

.input-icon input:focus + i, .input-icon select:focus + i {
  color: #fff;
  background-color: #3a86ff;
}

.input-icon input:focus {
    outline: none;
}

.radio-field {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.radio-icon {
    display: flex;
    justify-content: space-between;
    border: solid 2px #aaa;
    border-radius: 5px;
    margin-top: -5px;

}

.radio-icon > div {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    width: 100%;
}

.radio-icon i {
    background-color: #aaa;
    color: #fff;
    padding: 10px 8px;
    transition: 0.3s;
}

.radio-icon:hover i{
    color: #fff;
    background-color: #3a86ff;
}

.radio-icon:hover {
    border-color: #3a86ff;
    box-shadow: 0 0 8px 0 #3a86ff;
}

.radio-label {
    display: flex;
    align-items: center;
}

[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
}

[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
}

[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2px solid #aaa;
    border-radius: 100%;
}

[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
    content: '';
    width: 12px;
    height: 12px;
    background: #3a86ff;
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}

[type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}

[type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}

.modal-mask {
  position: fixed;
  z-index: 2;
  top: 30px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
    display: flex;
    flex-direction: column;
    width: 50%;
    height: 85%;
    max-height: 550px;
    margin: 0px auto;
    padding: 10px 30px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-body {
    overflow-y: auto;
}

.modal-body::-webkit-scrollbar-track, textarea::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
	border-radius: 2px;
	background-color: #F5F5F5;
}

.modal-body::-webkit-scrollbar-thumb, textarea::-webkit-scrollbar-thumb {
	border-radius: 2px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.1);
	background-color: #555;
}

.modal-body::-webkit-scrollbar, textarea::-webkit-scrollbar {
    width: 10px;
	background-color: #F5F5F5;
}

.modal-header h3 {
    margin-top: 0;
    font-weight: 600;
}

.modal-header i {
    font-size: 20px;
    cursor: pointer;
}

.modal-header i:hover {
    color: red;
    transition: 0.2s;
}

.modal-footer {
    float: right;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal-footer {
    display: flex;
    justify-content: space-between;
}

.modal-footer .last-edit {
    font-size: 0.9em;
    font-weight: 600;
    color: #aaa;
}

.modal-footer .buttons button {
    font-weight: bold;
    border-radius: 5px !important;
}
</style>
